import React, { useState } from 'react';
import OperatorMultiSelect from './OperatorMultiSelect.jsx';

export default function CompactOperatorAccess(props) {
  const [editing, setEditing] = useState(false);
  const selected = [...new Set(
    String(props.value ?? '')
      .split(/[,\s;]+/)
      .map((id) => id.trim())
      .filter(Boolean),
  )];
  const people = new Map(
    (Array.isArray(props.users) ? props.users : [])
      .map((person) => [String(person.id), person]),
  );
  const label = (id) => {
    const person = people.get(id);
    const name = [person?.last_name, person?.name]
      .filter(Boolean).join(' ').trim();
    return `${name || 'Сотрудник'} · № ${id}`;
  };

  if (editing) {
    return (
      <div style={{ minWidth: 0, width: '100%' }}>
        <OperatorMultiSelect {...props} />
        <div style={{ textAlign: 'right', marginTop: 6 }}>
          <button
            type="button"
            disabled={props.disabled}
            onClick={() => setEditing(false)}
            style={{
              border: '1px solid #bcd5f4',
              borderRadius: 7,
              background: '#fff',
              color: '#1766b2',
              padding: '6px 10px',
              cursor: 'pointer',
              fontSize: 12,
            }}
          >
            Готово
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      width: '100%', minWidth: 0,
      display: 'flex', alignItems: 'center',
      flexWrap: 'wrap', gap: 6, minHeight: 34,
    }}>
      {selected.length ? selected.slice(0, 2).map((id) => (
        <span
          key={id}
          title={label(id)}
          style={{
            fontSize: 12,
            padding: '5px 8px',
            color: '#174777',
            background: '#e8f2ff',
            borderRadius: 6,
          }}
        >
          {label(id)}
        </span>
      )) : (
        <span style={{ color: '#718096', fontSize: 13 }}>
          Никто не назначен
        </span>
      )}
      {selected.length > 2 && (
        <button
          type="button"
          title={selected.slice(2).map(label).join(', ')}
          disabled={props.disabled || props.loading || Boolean(props.error)}
          onClick={() => setEditing(true)}
          style={{
            fontSize: 12,
            padding: '5px 8px',
            border: 0,
            borderRadius: 6,
            background: '#edf2f7',
            color: '#475569',
            cursor: 'pointer',
          }}
        >
          +{selected.length - 2}
        </button>
      )}
      <button
        type="button"
        disabled={props.disabled || props.loading || Boolean(props.error)}
        onClick={() => setEditing(true)}
        style={{
          marginLeft: 'auto',
          border: '1px solid #bcd5f4',
          borderRadius: 7,
          background: '#fff',
          color: '#1766b2',
          padding: '6px 10px',
          fontSize: 12,
          cursor: 'pointer',
        }}
      >
        Изменить
      </button>
      {props.error && (
        <span style={{ color: '#b45309', fontSize: 12 }}>
          Список сотрудников недоступен
        </span>
      )}
    </div>
  );
}
